import { DataBean } from "../DataBean";


export class DOCRepository extends DataBean {

    public async getDOCRepository(iddocrepository: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCRepository_getDOCRepository_Number", [iddocrepository]);
    }

    public async getDOCRepositoryCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCRepositoryCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCRepository(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCRepository_updateDOCRepository_com.advantage.forms.bean.DOCRepository", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCRepository"
            }
        ]);
    }

}